import React from 'react';

import CenterLoadingSpinner from '../../../components/LoadingSpinner/CenterLoadingSpinner';
import FilePreviewRenderProps from '../FilePreviewRenderProps';
import useFileContentBlobUrl from '../useFileContent';

const IframeRenderer: React.FC<FilePreviewRenderProps> = (props) => {
  const fileUrl = useFileContentBlobUrl(props.file.id, props.version?.id);

  if (fileUrl == null) {
    return <CenterLoadingSpinner />;
  }

  return <iframe className='w-full h-[calc(85vh+4px)]' src={fileUrl} />;
}

export default IframeRenderer;